export const BASE_SELECT_FIRST_OPTION = "Choose";

export const BASE_INPUT_ROW = {display:'flex', alignItems:'center', height:'40px'};
export const BASE_LABEL = {display:'flex', fontSize:'14px', paddingLeft:'10px', color:'black', minWidth:'120px'};
export const BASE_SELECT = {display:'flex', height:'30px', minWidth:'250px', border:'1px solid lightgrey', borderRadius:'6px', color:'black', backgroundColor:'rgba(0,0,0,0)', paddingLeft:'10px', fontSize:'14px'};
export const BASE_BUTTON = {display:'flex', backgroundColor:'black', fontSize:'14px', borderRadius:'10px', cursor:'pointer', color:'white', width:'200px', alignItems:'center', justifyContent:'space-around', height:'30px', boxShadow: "0 2px 4px rgba(0,0,0,0.5)", background: "linear-gradient(180deg, #3A3A3A 0%, #111 100%)"};

export const BASE_LABEL_DARK = {display:'flex', fontSize:'14px', paddingLeft:'10px', color:'lightgrey', minWidth:'120px'};
export const BASE_SELECT_DARK = {display:'flex', height:'30px', minWidth:'220px', border:'1px solid #444', borderRadius:'6px', color:'white', backgroundColor:'rgba(0,0,0,0)', paddingLeft:'10px', fontSize:'14px'};


export const CARD_STYLE =
{
    background:
        "linear-gradient(180deg, #ffffff 0%, #f3f5f6 100%)",

    borderRadius:
        "0px",

		border:
		    "1px solid rgba(20,35,50,0.045)",

		boxShadow:
		    "0 2px 3px rgba(20,35,50,0.14), 0 6px 9px rgba(20,35,50,0.18)"
};


export const CARD_STYLE_LARGE =
{
    background:
        "linear-gradient(180deg, #ffffff 0%, #f3f5f6 100%)",

    borderRadius:
        "0px",

    border:
        "1px solid rgba(20,35,50,0.045)",

    boxShadow:
        "0 2px 3px rgba(20,35,50,0.14), 0 6px 9px rgba(20,35,50,0.18)",

    overflow:
        "hidden"
};


export const CHART_CONTAINER_STYLE = {
  display: "flex",
  width: "calc(100% - 50px)",
  flexDirection: "column",
  height: "calc(100% - 30px)",
  margin: "15px",
  padding: "10px",

  /* Surface */
  //background: "linear-gradient(180deg, #ffffff 0%, #e8ebf0 100%)",
  borderRadius: "8px",

  /* Micro definition */
  //border: "1px solid rgba(0,0,0,0.06)",
  //boxShadow: "0 1px 2px rgba(0,0,0,0.08)",

  color: "#333"
};


export const CARD_HEADER_BACKGROUND = 'linear-gradient(180deg, #ffffff 0%, #f7f8fa 100%)';
export const GREY_GRADIENT_PANEL_BACKGROUND = 'linear-gradient(180deg, #f5f6f7 0%, #ebedef 100%)';
export const ADMIN_PANEL_BACKGROUND_COLOR = '#f8f9fb';
export const NON_HERO_BACKGROUND = "#eef2f5";
export const DEFAULT_BLUE_GRADIENT = "linear-gradient(145deg, #5a9bd6, #3f7fb8)";

export const utilityDashboardComponentContainer = {
	display:"flex",
	flexDirection:"column",
	flexGrow:1
};

export const CARD_STYLE_STRETCH = {
	display:'flex',
	background: "#ffffff",
	//border: "1px solid #e3e6ea",
	borderRadius: "4px",
	//boxShadow: "none",
	flexDirection:"column",
	flexGrow:1,
	alignItems:'center',
	justifyContent:'space-around',
	paddingTop:'20px',
	paddingBottom:'20px',
	border: "1px solid rgba(0,0,0,0.04)",
};


export const DRAWER_BACKGROUND = "linear-gradient(180deg, #1a1d21 0%, #0b0d10 100%)";



export const DASHBOARD_TABLE_STYLE =
{
    width:
        "100%",

    borderCollapse:
        "collapse"
};


export const DASHBOARD_ROW_STYLE =
{
    display:
        "flex",

    flexDirection:
        "row",

    alignItems:
        "stretch",

    //--------------------------------------------------------
    // Tight tile separation
    //--------------------------------------------------------
    gap:
        "8px",

    //--------------------------------------------------------
    // Dashboard edge spacing
    //--------------------------------------------------------
    padding:
        "0 18px",

    //--------------------------------------------------------
    // Shadow channel between rows
    //--------------------------------------------------------
    marginBottom:
        "8px",

    boxSizing:
        "border-box"
};


export const DASHBOARD_COLUMN_STYLE =
{
    flex:
        1,

    minWidth:
        0,

    display:
        "flex",

    flexDirection:
        "column",

    alignSelf:
        "stretch",

    padding:
        "0",

    borderBottom:
        "none",

    borderRight:
        "none"
};
